<template>
  <div class="home">
    <Top v-if="!isAuthenticated" class="section-top" />
    <SliderFull v-if="isAuthenticated" />
    <Alert />
    <CustomAlert :alert-text="texts.alert" />
    <NotariusAction />
    <LastRequest v-if="isAuthenticated" />
    <Agreement :is-authenticated="isAuthenticated" />
    <!-- <FAQ /> -->
  </div>
</template>

<script>
import Top from '@/components/Home/sections/Top.vue';
import NotariusAction from '@/components/Home/sections/NotariusAction.vue';
import LastRequest from '@/components/Home/sections/LastRequest.vue';
// import FAQ from '@/components/Home/sections/FAQ.vue';
import { AuthModule } from '@/store/modules/auth';
import SliderFull from '@/components/Home/sections/SliderFull.vue';
import Alert from '@/components/Home/sections/Alert.vue';
import CustomAlert from '@/components/Home/sections/CustomAlert.vue';

import Agreement from '@/components/Home/Agreement.vue';
import {OtherModule} from "@/store/modules/other";

export default {
  name: 'Home',
  components: {Agreement, LastRequest, NotariusAction, CustomAlert, Alert, SliderFull, Top},
  data: () => ({
    texts: []
  }),
  async created() {
    this.texts = await OtherModule.getCustomTexts('home')
  },
  computed: {
    isAuthenticated() {
      return AuthModule.isAuthenticated;
    },
  },
}
</script>

<style lang="scss" scoped>
.section-top {
  margin-bottom: 30px;

  @media screen and (max-width: $gr-md) {
    margin-bottom: 30px;
  }
}
</style>
